import { useEffect, useState, useRef } from "react";
import {
  GeoJSON,
  MapContainer,
  TileLayer,
  useMap,
  Marker,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const markerIcon = new L.Icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [25, 30],
  iconAnchor: [17, 46],
  popupAnchor: [0, -46],
});

const MapController = ({ bounds }) => {
  const map = useMap();

  useEffect(() => {
    if (bounds && bounds.isValid()) {
      map.fitBounds(bounds);
    }
  }, [bounds, map]);

  return null;
};

const getColor = (ACS) => {
  if (ACS === null || ACS === undefined) return "blue";
  if (ACS < 50) return "red";
  if (ACS >= 50 && ACS <= 60) return "yellow";
  return "green";
};
const FarmerCropHealthMap = ({
  boundary,
  acs,
  height,
  boundaryUpdated,
  latLong,
}) => {
  const defaultPosition = [22.6139, 80.209];
  const [bounds, setBounds] = useState(null);
  const mapRef = useRef(null);

  useEffect(() => {
    if (boundary && Object.keys(boundary).length) {
      const features = [boundary];
      const calculatedBounds = L.geoJSON(features).getBounds();
      setBounds(calculatedBounds);
    }
  }, [boundary]);

  return (
    <div style={{ height: height, width: "100%" }} ref={mapRef}>
      <MapContainer
        center={latLong || defaultPosition}
        zoom={12}
        style={{ height: "100%", width: "100%" }}
        className="leaflet-container"
        maxZoom={22}
      >
        <TileLayer
          url="https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
          maxZoom={22}
        />

        {boundary && boundaryUpdated && Object.keys(boundary).length > 0 ? (
          <GeoJSON
            key={JSON.stringify(boundary)}
            data={boundary}
            style={() => ({
              color: getColor(acs),
              weight: 2,
              fillOpacity: 0.5,
            })}
          />
        ) : (
          latLong && <Marker icon={markerIcon} position={latLong} />
        )}
        {bounds && (
          <MapController key={JSON.stringify(bounds)} bounds={bounds} />
        )}
      </MapContainer>
    </div>
  );
};

export default FarmerCropHealthMap;
